@if (!hideHeader) {
  <app-header class="lay-wrapper lay-wrapper--header mat-elevation-z8"></app-header>
}
<div class="main-content-wrapper">
  <router-outlet id="main-content"></router-outlet>
</div>
